export const MAPPING_FILE_COLUMN_NAMES_BY_KEY = {
  machineAlias: 'exportCleaningReport.dialog.machine',
  pathCoverage: 'exportCleaningReport.dialog.coverage',
  machineSerialNumber: 'exportCleaningReport.dialog.serialNumber',
  machineMaterialNumber: 'exportCleaningReport.dialog.materialNumber',
  machineFacility: 'exportCleaningReport.dialog.facility',
  machineObject: 'exportCleaningReport.dialog.object',
  duration: 'exportCleaningReport.dialog.duration',
  cleanedSquareMeter: 'exportCleaningReport.dialog.cleanedMeterSquare', // to be considered in logic implementation
  cleanedSquareFeet: 'exportCleaningReport.dialog.cleanedFeetSquare', // to be considered in logic implementation
  taskCompletion: 'exportCleaningReport.dialog.taskCompletion',
  createdAt: 'exportCleaningReport.dialog.date',
  startDate: 'exportCleaningReport.dialog.startTime',
  endDate: 'exportCleaningReport.dialog.endTime',
  routeName: 'exportCleaningReport.dialog.routeName'
};

export const CHECKBOX_PER_GRID_COLUMN = 4;
